import React from 'react';
import { useForm } from 'react-hook-form';
import CrudEdit from '~/components/CrudEdit';
import IUnitMeasurement from '../interfaces/IUnitMeasurement';


export default function Edit() {     
  const {register, handleSubmit, control, setValue:setFormValue, getValues} = useForm<IUnitMeasurement>();
  const fields = [
      { name: 'id', type: 'hidden'},
      { name: 'name', type: 'string'},
  ];
  
    return(
      <CrudEdit 
        model={'unit-measurement'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        setFormValue={setFormValue}
        messageSuccess={'Unit Measurement successfully updated!'}  
        title={'Edit unit measurement'}
        getValues={getValues} 
      />
    )
}
